(() => {
  const bind = (scope = document) => {
    scope.querySelectorAll('[data-nb-product]').forEach((product) => {
      if (product.dataset.bound) return;
      product.dataset.bound = 'true';
      const mainLink = product.querySelector('[data-main-image-link]');
      const mainImage = mainLink?.querySelector('img');
      const updateImage = (src, full, alt) => {
        if (!mainImage || !src) return;
        mainImage.removeAttribute('srcset');
        mainImage.src = src;
        if (alt) mainImage.alt = alt;
        mainLink.href = full || src;
      };
      product.querySelectorAll('[data-gallery-image]').forEach((button) => {
        button.addEventListener('click', () => updateImage(button.dataset.src, button.dataset.full, button.dataset.alt));
      });
      const variantSelect = product.querySelector('[data-variant-select]');
      const submit = product.querySelector('[data-product-submit]');
      const stickySubmit = product.querySelector('[data-sticky-submit]');
      const price = product.querySelector('[data-product-price]');
      const stickyPrice = product.querySelector('[data-sticky-price]');
      variantSelect?.addEventListener('change', () => {
        const option = variantSelect.selectedOptions[0];
        const available = option.dataset.available === 'true';
        price.textContent = option.dataset.price;
        stickyPrice.textContent = option.dataset.price;
        [submit, stickySubmit].filter(Boolean).forEach((button) => {
          button.disabled = !available;
          button.textContent = available ? submit.dataset.addLabel : submit.dataset.soldLabel;
        });
        updateImage(option.dataset.image, option.dataset.full);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState({}, '', url);
      });
      const form = product.querySelector('.nb-product-form');
      const sticky = product.querySelector('[data-sticky-buy]');
      if ('IntersectionObserver' in window && form && sticky) {
        const observer = new IntersectionObserver(([entry]) => {
          sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
        }, { threshold: 0 });
        observer.observe(form);
        document.addEventListener('shopify:section:unload', (event) => {
          if (event.target.contains(product)) observer.disconnect();
        });
      }
    });
    scope.querySelectorAll('[data-sort-select]').forEach((select) => {
      if (select.dataset.bound) return;
      select.dataset.bound = 'true';
      select.addEventListener('change', () => select.form.requestSubmit());
    });
    scope.querySelectorAll('.nb-mobile-menu').forEach((menu) => {
      if (menu.dataset.bound) return;
      menu.dataset.bound = 'true';
      menu.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          menu.open = false;
          menu.querySelector('summary').focus();
        }
      });
      menu.querySelectorAll('a').forEach((a) => a.addEventListener('click', () => { menu.open = false; }));
    });
  };
  bind();
  document.addEventListener('shopify:section:load', (event) => bind(event.target));
})();
